let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hu8IH")).then(() => parcelRequire('k0xxC'));